export default __webpack_public_path__ + "static/media/laptop-man-wide.254e0fc9.png";